// extracted by mini-css-extract-plugin
export default {"menu":"SubMenu_menu__Chduk","menu-item":"SubMenu_menu-item__tZce1","active":"SubMenu_active__6ZjTc"};